import React, { Component } from 'react'
import { connect } from 'react-redux'
import ModalWrapper, { withOnClose } from '../../../../../components/Modal/ModalWrapper'
import MundialButton from '../../../FootballMatchDetail/Components/MundialButton/MundialButton'
import CountryDetailsHeader from './Components/CountryDetailsHeader'
import CountryDetailsBody from './Components/CountryDetailsBody'
import Utils from '../../../../../utils/Utils'
import { getNodeCode } from '../../../utils'
import { getStatisticsCountryDetails } from '../../../services/CountryDetailsServices/getStatisticsCountryDetails'
import { setToggleState } from '../../../../../actions/toggles'
import './_styles.scss'

/**
 * CountryDetailsModal
 * Contenedor con scroll programático + ScrollIndicator.
 * No renderiza contenido propio; acepta children.
 *
 * Props:
 *  onUpAtTop      {func}   — callback cuando UP se presiona en scrollTop = 0
 *  trackHeightRem {number} — alto del track del scrollbar en rem
 *  thumbHeightRem {number} — alto del thumb del scrollbar en rem
 */
class CountryDetailsModal extends Component {
  constructor (props) {
    super(props)
    this.state = { dataHeader: null, dataStats: null }
    this.handleClose = this.handleClose.bind(this)
    this.handleMundialButtonKeyDown = this.handleMundialButtonKeyDown.bind(this)

    const code = getNodeCode()
    const metadataValue = Utils.getApaMetadataKey('sports_competition_config', null)
    this.idLeague = metadataValue && metadataValue[code] ? metadataValue[code].leagueId : null
    this.teamViewParam = "statistics"
  }

  async componentDidMount() {
    const { dataHeader, dataStats } = await getStatisticsCountryDetails(this.idLeague, this.teamViewParam, this.props.countryId)
    this.setState({ dataHeader: dataHeader })
  }

  handleMundialButtonKeyDown (e) {
    if (e.key === 'ArrowRight' || e.key === 'Right') {
      e.preventDefault()
      e.stopPropagation()
      var favorite = document.querySelector('.country-details-header__favorite-country-wrapper')
      if (favorite) favorite.focus()
    }
  }

  handleClose () {
    const pathname = window.location.pathname;
    const getLasFocusItem = pathname.includes("mundial2026") ? localStorage.getItem('lastFocusPais') : false;
    if (getLasFocusItem) {
      Utils.setInitialFocusChangeTime(getLasFocusItem, 500);
    }
    // Resetear ambos toggles a false antes de cerrar el modal
    this.props.setToggleState('squad-body', false)
    this.props.setToggleState('stats-body', false)
    
    const { handleClose, callback } = this.props
    if (typeof handleClose === 'function') handleClose(null, callback)
  }

  render () {
    const modalProps = {
      alwaysEnabled: true,
      aafNewStyle: true,
      className: 'aaf-modal country-details-modal',
      showLogo: false,
      classNameComponent: 'modal-country-details',
      callbackWhenBack: this.handleClose
    }

    return (
      <ModalWrapper {...modalProps}>
        <div className='country-details__content'>
          <div className='country-details__mundial-button' onKeyDown={this.handleMundialButtonKeyDown}>
            <MundialButton
              onClick={this.handleClose}
              id='btnCountryDetailsBack'
              className='focusable'
            />
          </div>
          <CountryDetailsHeader
            dataHeader={this.state.dataHeader}
            countryId={this.props.countryId}
            onClickFavorite={this.props.onClickFavorite}
          />
          <CountryDetailsBody 
          countryId={this.props.countryId}
          mainMenuLabel={this.props.mainMenuLabel}
          parentTabLabel={this.props.parentTabLabel}
          childTabLabel={this.props.childTabLabel}
          >
            {this.props.children}
          </CountryDetailsBody>
        </div>
      </ModalWrapper>
    )
  }
}

function mapDispatchToProps(dispatch) {
  return {
    setToggleState: function (toggleId, active) {
      return dispatch(setToggleState(toggleId, active))
    }
  }
}

export default connect(null, mapDispatchToProps)(withOnClose(CountryDetailsModal))



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/Paises/components/CountryDetailsModal/index.jsx